export const COMMAND_PALETTE_CONTAINER_TEST_ID =
	'shared-layout.ui.global.command-palette-container';

export const DARK_THEME_BENEFITS_MODAL_TEST_ID = 'darktheme-benefits-modal.ui.modal';

export const ISSUE_TRANSITION_MODAL_TEST_ID = 'issue-transition.ui.modal';
